module.exports = __webpack_public_path__ + "static/media/TempcoverBrandLogo.6c8d6723.png";